// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import { AdminRoute, OrderConsole } from './components/admin';
import { Login, Signup, ResetPassword } from './components/auth';
import { PaymentPage } from './components/payment';
import { SettingsPage, ProductManagerPage } from './components/setting';
import BarOrderDashboard from './components/bar/BarOrderDashboard';
import StoreStatusPage from './components/storeStatus/StoreStatusPage';
import './App.css';

// プライベートルート - 認証済みのユーザーのみアクセス可能
const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">読み込み中...</div>;
  }
  
  return currentUser ? children : <Navigate to="/login" />;
};

// 既に認証済みの場合にリダイレクトするルート
const PublicRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">読み込み中...</div>;
  }
  
  return !currentUser ? children : <Navigate to="/dashboard" />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app">
          <Routes>
            <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/signup" element={<PublicRoute><Signup /></PublicRoute>} />
            <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><BarOrderDashboard /></PrivateRoute>} />
            <Route path="/payment" element={<PrivateRoute><PaymentPage /></PrivateRoute>} />
            <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
            <Route path="/store-status" element={<PrivateRoute><StoreStatusPage /></PrivateRoute>} />
            <Route path="/admin/orders" element={
              <PrivateRoute>
                <AdminRoute>
                  <OrderConsole />
                </AdminRoute>
              </PrivateRoute>
            } />
            <Route path="/admin/products" element={
              <PrivateRoute>
                <AdminRoute>
                  <ProductManagerPage />
                </AdminRoute>
              </PrivateRoute>
            } />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;